// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import { withStyles, Paper } from "@material-ui/core";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import { Button } from "./button";
import { compose } from "recompose";
import { withStore } from "../store/withstore";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
	root: {
		color: "#303C49",
		fontFamily: "'MANEurope', sans-serif",
		fontWeight: 300,
		padding: "1rem"
	},
	wrapper: {
		display: "flex",
		alignItems: "center"
	},
	actions: {
		display: "flex",
		justifyContent: "flex-end",
		padding: "1rem 0 0"
	}
});

export const extractGraphqlError = (error) => {
	if (typeof error === "string") {
		return error;
	}

	if (!error) {
		return "An unknown error occurred.";
	}

	if (Array.isArray(error.graphQLErrors) && error.graphQLErrors.length > 0) {
		return error.graphQLErrors[0].message;
	}

	return error.message;
};

export let Error = withStyles(styles)((props) => {
	const { classes, message } = props;

	const restartCalculation = () => {
		props.storeAction.reset();
		props.history.push("/tco-lcc");
	};

	return (
		<Paper className={classes.root}>
			<div className={classes.wrapper}>
				<ErrorOutline color="error" style={{ marginRight: "1rem" }}/>
				{extractGraphqlError(message)}
			</div>
			<div className={classes.actions}>
				<Button variant="outlined" onClick={restartCalculation}>Restart calculation</Button>
			</div>
		</Paper>
	);
});

Error = compose(
	withStyles(styles),
	withStore,
	withRouter
)(Error);

Error.propTypes = {
	message: PropTypes.string,
	storeAction: PropTypes.object,
	history: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/tco/components/error.js